import { render, staticRenderFns } from "./waved-items.vue?vue&type=template&id=d9aab6ec&"
import script from "./waved-items.vue?vue&type=script&lang=js&"
export * from "./waved-items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports